import { useEventListener } from '@vueuse/core';
import { debounce } from 'lodash';
/**
 * 用于给button节流
 */
interface ElType extends HTMLElement {
  disabled: boolean;
}
const setDisabledFun = (el: ElType) => {
  return () => {
    const d = debounce((el) => {
      // 半秒后恢复点击状态
      el.disabled = false;
    }, 500);
    if (!el.disabled) {
      el.disabled = true;
      d(el);
    }
  };
};
export default {
  mounted(el: ElType) {
    useEventListener(el, 'click', setDisabledFun(el));
  },
};
